import type { IntegrationProvider } from 'findef'

export const FINSQUID_STORAGE_KEY = 'finsquid'

export interface IFinsquidStorage {
  sid?: string
  provider?: IntegrationProvider
}
